import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const PortalPage: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const canvas = canvasRef.current!;
    const ctx = canvas.getContext('2d')!;
    let stars: { x: number; y: number; r: number; alpha: number; speed: number; phase: number }[] = [];
    const COUNT = 160;
    let animId = 0;

    const resize = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
    const createStars = () => {
      stars = [];
      for (let i = 0; i < COUNT; i++) {
        stars.push({
          x: Math.random() * canvas.width, y: Math.random() * canvas.height,
          r: Math.random() * 1.4 + 0.3, alpha: Math.random() * 0.6 + 0.2,
          speed: Math.random() * 0.015 + 0.005, phase: Math.random() * Math.PI * 2,
        });
      }
    };
    const draw = (t: number) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach((s) => {
        const a = s.alpha * (0.6 + 0.4 * Math.sin(t * s.speed + s.phase));
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(180, 235, 210, ${a})`; ctx.fill();
      });
      animId = requestAnimationFrame(draw);
    };

    resize(); createStars(); animId = requestAnimationFrame(draw);
    const onResize = () => { resize(); createStars(); };
    window.addEventListener('resize', onResize);
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', onResize); };
  }, []);

  return (
    <div style={{
      minHeight: '100vh', background: 'linear-gradient(135deg, #0a1f14 0%, #0d3320 45%, #0a4a30 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      fontFamily: '-apple-system, "PingFang SC", "Microsoft YaHei", "Segoe UI", sans-serif',
      position: 'relative', overflow: 'hidden',
    }}>
      <canvas ref={canvasRef} style={{ position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none' }} />

      {/* Header */}
      <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', marginBottom: 56, animation: 'fadeDown 0.8s ease both' }}>
        <div style={{
          display: 'inline-block', padding: '4px 14px', border: '1px solid rgba(52,211,153,0.5)',
          borderRadius: 20, fontSize: 12, color: 'rgba(52,211,153,0.9)', letterSpacing: 2,
          marginBottom: 16, background: 'rgba(52,211,153,0.08)',
        }}>INTEGRATED EDUCATION PLATFORM</div>
        <h1 style={{
          fontSize: 'clamp(20px, 3.2vw, 32px)', fontWeight: 700, color: '#fff',
          letterSpacing: 3, lineHeight: 1.3, textShadow: '0 0 30px rgba(52,211,153,0.4)',
        }}>北京师范大学亚太实验学校综合教育平台</h1>
        {/* 副标题已删除 */}
      </div>

      {/* Cards */}
      <div style={{ position: 'relative', zIndex: 1, display: 'flex', gap: 40, flexWrap: 'wrap', justifyContent: 'center', animation: 'fadeUp 0.9s ease 0.15s both' }}>
        {/* 少科院 */}
        <div onClick={() => navigate('/login')} title="少科院管理系统" style={{
          width: 240, height: 280, borderRadius: 20, display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: 18, cursor: 'pointer',
          position: 'relative', overflow: 'hidden',
          background: 'rgba(255,255,255,0.06)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)',
          border: '1px solid rgba(255,255,255,0.12)',
          boxShadow: '0 8px 40px rgba(22,163,74,0.25)',
          transition: 'transform 0.35s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.35s ease',
        }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)'; e.currentTarget.style.boxShadow = '0 18px 60px rgba(22,163,74,0.35)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 8px 40px rgba(22,163,74,0.25)'; }}
        >
          <div style={{
            width: 88, height: 88, borderRadius: 24, display: 'flex', alignItems: 'center',
            justifyContent: 'center', fontSize: 42, lineHeight: 1,
            background: 'linear-gradient(135deg, #16a34a 0%, #10b981 100%)',
            boxShadow: '0 6px 24px rgba(22,163,74,0.5)',
          }}>🏛️</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#fff', letterSpacing: 2 }}>少 科 院</div>
          <div style={{ fontSize: 12, color: 'rgba(200,230,210,0.55)', letterSpacing: 1, marginTop: -10 }}>
            青少年科技创新学院 · 管理系统
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{ position: 'relative', zIndex: 1, marginTop: 60, fontSize: 12, color: 'rgba(120,190,160,0.4)', letterSpacing: 1, animation: 'fadeUp 1s ease 0.3s both' }}>
        © 2026 &nbsp;北京师范大学亚太实验学校 &nbsp;·&nbsp; 保留所有权利
      </div>

      {/* Keyframes injected once */}
      <style>{`
        @keyframes fadeDown { from { opacity: 0; transform: translateY(-24px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
        @media (max-width: 560px) { .cards-wrap { gap: 24px !important; } .card-box { width: 200px !important; height: 240px !important; } }
      `}</style>
    </div>
  );
};

export default PortalPage;
